import React from 'react'
import { storiesOf } from '@storybook/react'
import { withKnobs, number, boolean } from '@storybook/addon-knobs/react'

import BudgetIndicator from 'components/BudgetIndicator'

storiesOf('BudgetIndicator', module)
  .addDecorator(withKnobs)
  .add('default', () => {
    const total: number = number('Budget', 16)
    const remaining: number = number('Remaining budget', 6, { min: 0, max: total * 2, step: 1 })
    const tooManyGKs: boolean = boolean('GK Error', false)

    return (
      <BudgetIndicator
        totalBudget={total}
        remainingBudget={remaining}
        hasTooManyGoalkeepers={tooManyGKs}
      />
    )
  })
